module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjMyMiIgaGVpZ2h0PSIxNi4zMDUiIHZpZXdCb3g9IjAgMCA5LjMyMiAxNi4zMDUiPg0KICA8cGF0aCBpZD0iSWNvbl9pb25pYy1pb3MtYXJyb3ctYmFjayIgZGF0YS1uYW1lPSJJY29uIGlvbmljLWlvcy1hcnJvdy1iYWNrIiBkPSJNMi44MSw4LjE1NSw4Ljk4LDE0LjMxOWExLjE2NSwxLjE2NSwwLDEsMS0xLjY1LDEuNjQ2TC4zMzksOC45OEExLjE2MywxLjE2MywwLDAsMSwuMzA1LDcuMzczTDcuMzI0LjM0YTEuMTY1LDEuMTY1LDAsMCwxLDEuNjUsMS42NDZaIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./static/blog/img/icn_previous.svg
// module id = 2iqw
// module chunks = 0